import { IScore } from "../score";

export enum TonesetText {
    Empty = 1,
    Solfa = 2,
    Abc = 3,
    Handsign = 4,
}

export interface ITonesetStaffData {
    color: string,
    hint?: boolean,
    size: {
        y: number,
    },
    position: number,
    method: TonesetText,
    score?: IScore,
    tempo?: number,
}